export default __webpack_public_path__ + "static/logo-2fcc383a1026ef75fff13af6bb6a2451.svg";